import { render, staticRenderFns } from "./AssignedProperties.vue?vue&type=template&id=471b01db"
import script from "./AssignedProperties.vue?vue&type=script&lang=js"
export * from "./AssignedProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports